/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteMultipleTimeRegsInput = {|
  ids?: ?$ReadOnlyArray<?string>,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteAllTimeRegistrationsForWeekMutationVariables = {|
  input: DeleteMultipleTimeRegsInput
|};
export type deleteAllTimeRegistrationsForWeekMutationResponse = {|
  +deleteMultipleTimeRegs: ?{|
    +deletedTimeRegIds: ?$ReadOnlyArray<?string>,
    +viewer: ?{|
      +id: string
    |},
    +errors: ?$ReadOnlyArray<?string>,
  |}
|};
export type deleteAllTimeRegistrationsForWeekMutation = {|
  variables: deleteAllTimeRegistrationsForWeekMutationVariables,
  response: deleteAllTimeRegistrationsForWeekMutationResponse,
|};
*/


/*
mutation deleteAllTimeRegistrationsForWeekMutation(
  $input: DeleteMultipleTimeRegsInput!
) {
  deleteMultipleTimeRegs(input: $input) {
    deletedTimeRegIds
    viewer {
      id
    }
    errors
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMultipleTimeRegsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteMultipleTimeRegsPayload",
    "kind": "LinkedField",
    "name": "deleteMultipleTimeRegs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedTimeRegIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteAllTimeRegistrationsForWeekMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteAllTimeRegistrationsForWeekMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteAllTimeRegistrationsForWeekMutation",
    "operationKind": "mutation",
    "text": "mutation deleteAllTimeRegistrationsForWeekMutation(\n  $input: DeleteMultipleTimeRegsInput!\n) {\n  deleteMultipleTimeRegs(input: $input) {\n    deletedTimeRegIds\n    viewer {\n      id\n    }\n    errors\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '768c49a439c28bf08cd73c67759e136b';

module.exports = node;
